// @flow
import React, { Component } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import { hot } from 'react-hot-loader'
import './styles.scss'

class AppComponent extends Component<{}> {
  render() {
    let params = new URL(window.location).searchParams
    let imageToLoad = params.get('image')

    return (
      <img
        src={imageToLoad}
        style={{ width: '100%', height: 'auto', display: 'block' }}
      />
    )
  }
}

export default hot(module)(AppComponent)
